import ContextMenu from "src/components/ContextMenu/ContextMenu";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./MembersTab.module.scss";

interface CustomTransactionCellRendererProps extends CustomCellRendererProps {
  onEdit?: (rowData: any) => void;
  onRemove?: (rowData: any) => void;
  onSendMessage?: (rowData: any) => void;
  onSendDirectMessage?: (rowData: any) => void;
}

export const ActionsRenderer = (props: CustomTransactionCellRendererProps) => {
  const handleEdit = () => {
    if (props.onEdit) {
      props.onEdit(props.data);
    }
  };

  const handleRemove = () => {
    if (props.onRemove) {
      props.onRemove(props.data);
    }
  };

  const handleSendMessage = () => {
    if (props.onSendMessage) {
      props.onSendMessage(props.data);
    }
  };

  const handleSendDirectMessage = () => {
    if (props.onSendDirectMessage) {
      props.onSendDirectMessage(props.data);
    }
  };

  return (<div className={styles.ActionRenderer}>
    <ContextMenu
      options={[
        { 
          label: "Edit",
          onClick: handleEdit
        },
        { 
          label: "Send Email",
          onClick: handleSendMessage
        },
        { 
          label: "Send Message",
          onClick: handleSendDirectMessage
        },
        { 
          label: "Remove",
          onClick: handleRemove
        }
      ]}
    />
  </div>);
};
